import CreateDocumentGroup from './views/CreateDocumentGroup.vue'
import DocumentGroups from './views/DocumentGroups.vue'
import DocumentGroupDetail from './views/DocumentGroupDetail.vue'
import HomeLayout from '@/layouts/Home.vue'

export const documentRoutes = [
  {
    path: '/payrollsConfig/:id/documentGroups',
    name: 'documentGroups',
    component: DocumentGroups,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/:id/documentGroups/add',
    name: 'createDocumentGroup',
    component: CreateDocumentGroup,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/:id/documentGroups/detail/:documentGroupId',
    name: 'documentGroupDetail',
    component: DocumentGroupDetail,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin'],
    },
  },
]
